import { render } from "./BuyDetail.vue?vue&type=template&id=519e5e45"
import script from "./BuyDetail.vue?vue&type=script&lang=js"
export * from "./BuyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__